import { Home } from '../../assets/icons';
import { app as $appContent } from '../../content';

const $content = $appContent.navbar;

export const navMenuButtonData = [
  {
    label: $content.home,
    icon: <Home />,
    to: '/',
    pageName: 'channel_directory',
    allowedRoles: []
  }
];
